import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { map, Observable } from 'rxjs'
import { ServiceUrlConstants } from 'src/constants/service-url-constants'
import { AutomationProcessListAPIModel, ListExpenseAPIRequest, PaginatedAPI } from 'src/models/api.model'
import { AppState } from 'src/store/state/app.state'
import { WebService } from '../api/web.service'
import { getAutomationProcessRegisterList } from 'src/store/selector/automation-process-register.selector'

@Injectable({
  providedIn: 'root'
})
export class AutomationProcessRegisterService {
  constructor(private webService: WebService, private appState: Store<AppState>) {}

  callFetchAutomationProcessRegisterApi(payload: ListExpenseAPIRequest) {
    const url = `${ServiceUrlConstants.API_EXECUTION_LOG_LIST}?pageNo=${payload.pageInfo.pageNo}&limit=${payload.pageInfo.limit}&sortBy=${payload.sort.sortBy}&sortOrder=${payload.sort.sortOrder}`
    return this.webService
      .post(url, payload.filters)
      .pipe(map((data: PaginatedAPI<AutomationProcessListAPIModel>) => data))
  }

  getAutomationProcessRegisterListFromStore = (): Observable<PaginatedAPI<AutomationProcessListAPIModel>> => {
    return this.appState.select(getAutomationProcessRegisterList())
  }

  invokeRepostFileAPI(id: string) {
    let url = ServiceUrlConstants.API_FILE_REPOST.replace("{0}", id);
    return this.webService
      .get(url)
  }
}
